export const APPOINTMENT_TYPE_FLEXIBLE = 'slots_flexible';
export const APPOINTMENT_TYPE_FIXED = 'slots_fixed';
export const APPOINTMENT_TYPE_UNTIL_CANCEL = 'until_cancellation';
export const APPOINTMENT_TYPE_DAYS = 'days';
